// Inkle AI Onboarding Step Keys
export const AI_ONBOARDING_STEP_KEY = "AI_ONBOARDING";
export const AI_TOUR_STEP_KEY = "AI_TOUR";

export const AI_AGENT_OUTCOME_ONBOARDING = "onboarding";

// Onboarding Status Values
export const ONBOARDING_STATUS = {
  NOT_STARTED: "NOT_STARTED",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  SKIPPED: "SKIPPED",
} as const;

export type OnboardingStatus =
  (typeof ONBOARDING_STATUS)[keyof typeof ONBOARDING_STATUS];
